/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { TextField } from '@mui/material';
import { ReadOnlyTextFieldView } from '../ReadOnlyTextField.view';

interface Props {
	groupShortName: string;
	isReadOnlyField?: boolean;
	handleGroupShortNameChange?: (newGroupShortName: string) => void;
}

class GroupShortNameView extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.handleGroupShortNameChange = this.handleGroupShortNameChange.bind(this);
	}

	handleGroupShortNameChange(event: React.ChangeEvent<{ value: string }>): void {
		const { handleGroupShortNameChange } = this.props;
		handleGroupShortNameChange && handleGroupShortNameChange(event.target.value);
	}

	render(): JSX.Element {
		const { groupShortName, isReadOnlyField } = this.props;
		return isReadOnlyField ? (
			<ReadOnlyTextFieldView
				id="groupShortName"
				name="groupShortName"
				label="Gruppenkürzel"
				value={groupShortName}
				InputLabelProps={{ shrink: true }}
				InputProps={{ readOnly: true }}
				fullWidth
			/>
		) : (
			<TextField
				variant="standard"
				required
				id="groupShortName"
				name="groupShortName"
				label="Gruppenkürzel"
				value={groupShortName}
				onChange={this.handleGroupShortNameChange}
				InputLabelProps={{ shrink: true }}
				inputProps={{ maxLength: 2 }}
				fullWidth
			/>
		);
	}
}

export default GroupShortNameView;
